import moment from 'moment';
import * as XLSX from 'xlsx';

export const YYYYMMDD = (params) => {
    const date = new Date(params);

    let year = date.getUTCFullYear();
    let month = String(date.getUTCMonth() + 1).padStart(2, '0');
    let day = String(date.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const GenerateOrderId = () => {
    const prefix = "PB-";

    // Get current date and time
    const now = new Date();

    // Extract date parts (year, month, day)
    const year = now.getFullYear().toString(); // Full year
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(now.getDate()).padStart(2, '0');

    // Extract time parts
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0'); // Milliseconds for extra uniqueness

    // Combine date and time parts
    const dateTimeBasedNumber = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;

    // Slice to get a 12-15 digit number
    const uniqueNumber = dateTimeBasedNumber.slice(0, 14); // Adjust slice for desired length (12 to 15)

    // Combine prefix and unique number
    const customId = `${prefix}${uniqueNumber}`;

    return customId;
};

export const ConvertToLastDayOfMonth = (dateStr) => {
    // Split the input string into month and year
    const [month, year] = dateStr?.split('/');

    // Create a date object with the first day of the next month
    const nextMonthFirstDay = new Date(`20${year}`, month, 1);

    // Subtract one day to get the last day of the current month
    const lastDayOfMonth = new Date(nextMonthFirstDay - 1);

    // Format the date as YYYY-MM-DD
    const formattedDate = lastDayOfMonth?.toISOString()?.split('T')[0];

    return formattedDate;
};

//! Arrow Up Down Login
// export const handleKeyDown = (e, index, refArray) => {
//     const nextRef = refArray.current[index + 1]?.current;
//     const prevRef = refArray.current[index - 1]?.current;

//     if (e.key === 'ArrowDown' && nextRef) {
//         e.preventDefault();
//         nextRef.focus();
//     } else if (e.key === 'ArrowUp' && prevRef) {
//         e.preventDefault();
//         prevRef.focus();
//     }
// };
export const handleKeyDown = (e, index, refArray) => {
    const nextRef = refArray.current[index + 1]?.current;
    const prevRef = refArray.current[index - 1]?.current;

    // Prevent ArrowUp on index 0
    if (index === 0 && e.key === 'ArrowUp') {
        e.preventDefault(); // Prevents both default increment & focus shift
        return;
    }

    // Prevent ArrowDown on last index
    if (index === refArray.current.length - 1 && e.key === 'ArrowDown') {
        e.preventDefault();
        return;
    }

    if (e.key === 'ArrowDown' && nextRef) {
        e.preventDefault();
        nextRef.focus();
    } else if (e.key === 'ArrowUp' && prevRef) {
        e.preventDefault();
        prevRef.focus();
    }
};

//! Date Format For Inpur Field - YYYY-MM-DDTHH:mm
export const AdvanceDate = (advance) => {
    const advanceDate = moment().add(advance, 'days');
    return advanceDate.format('YYYY-MM-DDTHH:mm');
};

export const PreviousDate = (advance) => {
    const advanceDate = moment().subtract(advance, 'days');
    return advanceDate.format('YYYY-MM-DDTHH:mm');
};

//! Hide Date
export const HideDateFromCurrent = (year = 0) => {
    let currentDate = new Date();

    let newDate = new Date(currentDate);
    newDate.setFullYear(currentDate.getFullYear() - year);

    // Format the date as yyyy-mm-dd
    let formattedDate = newDate.toISOString().split("T")[0];
    return formattedDate;
};

//! Search
export const DeepSearch = (data, searchText) => {
    const searchLower = searchText.toLowerCase();

    const DeepSearchObject = (obj) => {
        if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(value => DeepSearchObject(value));
        }
        if (Array.isArray(obj)) {
            return obj.some(value => DeepSearchObject(value));
        }
        if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
            return obj.toString().toLowerCase().includes(searchLower);
        }
        return false;
    };

    return data && data.filter(item => DeepSearchObject(item));
};

export const DeepSearchSpace = (data, searchText) => {
    const normalizeText = (text) => text?.toLowerCase()?.replace(/\s+/g, '');

    const searchLower = normalizeText(searchText);

    const DeepSearchObject = (obj) => {
        if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(value => DeepSearchObject(value));
        }
        if (Array.isArray(obj)) {
            return obj.some(value => DeepSearchObject(value));
        }
        if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
            return normalizeText(obj.toString()).includes(searchLower);
        }
        return false;
    };

    return data && data.filter(item => DeepSearchObject(item));
};

//! Indian Rupee
export const IndianRupee = (rupee) => {

    let Rupee = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
    });

    return `${Rupee.format(rupee)}/-`
};

//! For XLXS File 
export const TransformData = (data) => {
    const headers = data[0];
    const transformed = data.slice(1).map(row => {
        const obj = {};
        // headers.forEach((header, index) => {
        //     obj[header] = row[index];
        // });
        headers.forEach((header, index) => {
            obj[header] = row[index] !== undefined ? row[index] : null; // Replace undefined with null
        });
        return obj;
    });
    return transformed;
};

export const ConvertAOBKeysToUpperCase = (data) => {
    return data.map(item => {
        const newItem = {};
        Object.keys(item).forEach(key => {
            newItem[key?.split('_').join(' ').toUpperCase().replace('+', '.')] = item[key];
        });
        return newItem;
    });
};

export const ExcelDownload = (title = 'Report', data) => {
    const upperData = ConvertAOBKeysToUpperCase(data);

    // Step 1: Create worksheet from JSON
    const ws = XLSX.utils.json_to_sheet(upperData, { origin: 'A3' }); // 👈 Table will start from Row 3

    // Step 2: Add custom heading in A1
    XLSX.utils.sheet_add_aoa(ws, [['Packtabs Pharm']], { origin: 'A1' });

    // Step 3: Merge heading across columns
    const numCols = Object.keys(upperData[0] || {}).length;
    if (!ws['!merges']) ws['!merges'] = [];
    ws['!merges'].push({
        s: { r: 0, c: 0 }, // start: row 1 col A
        e: { r: 0, c: numCols - 1 }, // end: row 1 col whatever
    });

    // Optional: Style the heading (not perfect — needs Excel to interpret styles)
    ws['A1'].s = {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: 'center' },
    };

    // Step 4: Create workbook and save
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, title);

    XLSX.writeFile(wb, `${title}.xlsx`);
    
    // const ws = XLSX.utils.json_to_sheet(data);
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, title);
    // // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // XLSX.writeFile(wb, `${title}.xlsx`);
};

//! Calculation
export const ptrBidAmount = (mrp, qty, fQty, ptr) => {
    console.log({ mrp, qty, fQty, ptr });

    const step1 = Number(mrp) * (1 - Number(28.57) / 100);
    const step2 = (step1 * qty) / (qty + fQty);

    const step3 = Number(step2) * (1 - Number(ptr) / 100);
    const step4 = Number(step3) * (1 + Number(12) / 100);
    return Number(step4.toFixed(2));
};

export const ptsBidAmount = (mrp, qty, fQty, pts) => {
    const step1 = Number(mrp) * (1 - Number(28.57) / 100);
    const step2 = Number(step1) * (1 - Number(10) / 100);

    const step3 = (step2 * qty) / (qty + fQty);

    const step4 = Number(step3) * (1 - Number(pts) / 100);
    const step5 = Number(step4) * (1 + Number(12) / 100);
    return Number(step5.toFixed(2));
};

export const downCalculationBidAmount = (mrp, down_calculation) => {
    const step1 = Number(mrp) * (1 - Number(23) / 100);
    const step2 = Number(step1) * (1 - Number(down_calculation) / 100);
    return Number(step2.toFixed(2));
};

export const mrpLessBidAmount = (mrp, mrp_less) => {
    const step1 = Number(mrp) * (1 - Number(mrp_less) / 100);
    return Number(step1.toFixed(2));
};

export const CalculateSaleAmount = (sale_rate, qty, dis, gst, fQty) => {
    console.log({ sale_rate, qty, dis, gst, fQty });

    if (fQty > 0 && fQty < 1) {
        console.log('If Block', { fQty });

        const step1 = Number(sale_rate) * Number(qty);
        const step2 = Number(sale_rate) * Number(fQty);
        const step3 = step1 - step2;
        const step4 = Number(step3) * (1 - Number(dis) / 100);
        return parseFloat(Number(step4) * (1 + Number(gst) / 100))?.toFixed(2);
    } else {
        console.log('Else Block', { fQty });

        const step1 = Number(sale_rate) * Number(qty);
        const step2 = Number(step1) * (1 - Number(dis) / 100);
        console.log("Else Return ::: ", parseFloat((Number(step2) * (1 + Number(gst) / 100))?.toFixed(2)))
        return parseFloat((Number(step2) * (1 + Number(gst) / 100))?.toFixed(2));
    }
};

export const CalculateSaleAmountOnNetRate = (net_rate, qty, dis, gst) => {
    // console.log({ net_rate, qty, dis, gst });

    const step1 = Number(net_rate) * (1 - Number(dis) / 100);
    return Number((qty * step1 * (1 + Number(gst) / 100)).toFixed(2));
};